import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  href?: string;
  onClick?: () => void;
  className?: string;
  subtext?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO EL MÉTODO CALMA® AHORA',
  href = 'https://checkout.ars.descargatop.com/cart/47490249588994:1',
  onClick,
  className = '',
  subtext
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };
  return <div className={`flex flex-col items-center w-full max-w-2xl mx-auto ${className}`} data-id="element-48">
      <a href={href} onClick={handleClick} className="relative w-full group block active:scale-[0.98] transition-transform" data-id="element-49">
        {/* Glow — box-shadow instead of blur filter */}
        <div className="absolute -inset-1 rounded-xl opacity-30 animate-cta-pulse" style={{
        boxShadow: '0 0 20px 8px rgba(34,197,94,0.5)'
      }} data-id="element-50" />

        {/* Main button */}
        <div className="relative w-full bg-gradient-to-b from-green-400 to-green-600 text-white font-black text-xl md:text-2xl lg:text-3xl py-5 px-4 rounded-xl shadow-[0_8px_0_rgb(21,128,61)] group-hover:shadow-[0_4px_0_rgb(21,128,61)] group-hover:translate-y-1 transition-all flex items-center justify-center text-center border-2 border-green-300" data-id="element-51">
          <span data-id="element-52">{text}</span>
          <ChevronRightIcon className="w-8 h-8 ml-2 hidden md:block" data-id="element-53" />
        </div>
      </a>

      {subtext && <p className="mt-4 text-sm md:text-base text-gray-500 font-medium text-center" data-id="element-54">
          {subtext}
        </p>}
    </div>;
}